module.exports = __webpack_public_path__ + "static/media/medaille2.7e834a92.png";